import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

import axios from "axios";
import { toast } from "react-toastify";
import config from '../../config';
import Layout from "../../components/layouts/Main";
import RfqDetailsHeader from "./components/rfq/RfqDetailsHeader";
import RfqItemList from "./components/rfq/RfqItemList";
import RfqResponsesTable from "./components/rfq/RfqResponsesTable";
import { PulseLoader } from "react-spinners";

const RfqDetails = () => {
  const { id } = useParams(); // expects /rfq/:id
  const [rfq, setRfq] = useState(null);

  const fetchRfq = useCallback(async () => {
    try {
      const res = await axios.get(`${config.API_BASE_URL}/rfqs/${id}`);
      setRfq(res.data);
    } catch (err) {
      console.error("Failed to fetch RFQ:", err);
    }
  }, [id]); // useParams().id is a dependency

  useEffect(() => {
    fetchRfq();
    if (sessionStorage.getItem('responseUpdated')) {
      toast.success('Response updated successfully!');
      sessionStorage.removeItem('responseUpdated');
    }
  }, [fetchRfq]);

  const handleResponseUpdated = () => {
    // Instead of reloading the whole page, refetch the RFQ so child components update.
    fetchRfq();
    toast.success('Response updated successfully!');
  };

  return (
    <Layout>
      {!rfq ? (
        <div className="text-center py-5"><PulseLoader color="#014b7cbb" size={9} /></div>
      ) : (
        <>
          <nav aria-label="breadcrumb" className="mb-3">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/purchase_requests">Purchase Requests</Link></li>
              <li className="breadcrumb-item"><Link to="/rfqs">RFQs</Link></li>

              <li className="breadcrumb-item active">#{rfq.rfq.rfq_id}</li>
            </ol>
          </nav>
          <RfqDetailsHeader rfq={rfq.rfq} />
          <RfqItemList items={rfq.items} />
          <RfqResponsesTable rfqId={rfq} fetchResponses={handleResponseUpdated} />
        </>
      )}
    </Layout>
  );
};

export default RfqDetails;
